import http from 'plugins/axios';
import Cookies from 'js-cookie';

export default {
  getAuditList(query) {
    return http.post({
      url: '/ta/admin/tenant/authRecord/search',
      data: {
        type: 0,
        ...query
      },
      dataType: 'form'
    });
  },
  getCountryCodeList() {
    return http.get({ url: '/ta/admin/tenant/countryCodeList' });
  },
  approveAudit({ id, backReason, status }) {
    return http.post({
      url: '/ta/admin/tenant/authRecord/update',
      data: {
        id,
        backReason,
        status
      },
      dataType: 'form'
    });
  },
  getAuditDetail(id) {
    return http.get({
      url: `/ta/admin/tenant/authRecord/detail/${id}`
    });
  },
  getoldDetail(id) {
    return http.get({
      url: `/ta/admin/tenant/authRecord/detail/oldUser/${id}`
    });
  },
  getExcel(data) {
    return http.get({
      url: '/ta/admin/tenant/authRecord/export',
      responseType: 'blob',
      data,
      // header:{
      //   Authorization:Cookies.get('admin-token')
      // }
    });
  },
  getIdOK(data) {
    return http.post({
      url: '/ta/admin/tenant/authRecord/search/oldUser',
      data,
      dataType: 'form'
    });
  },
  RollBack(data) {
    return http.post({
      url: '/ta/admin/tenant/authRecord/roll/back',
      data,
      dataType: 'form'
    });
  },
  delApi(data) {
    return http.post({
      url: '/ta/admin/tenant/authRecord/delete',
      data,
      dataType: 'form'
    });
  }
};
